module.exports = __webpack_public_path__ + "img/outOfScope.b28cd306.png";